import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export interface TenantSummary {
  // null when no defensible source exists — render a placeholder, never 0.
  thisMonthRevenue: { total: string } | null;
  outstandingInvoices: { count: number; amountDue: string };
  tenantFeesCollected: { count: number; total: string };
  // null when the contract has no enabled END_CUSTOMER_RECURRING component.
  endCustomerCharges: { merchantCount: number; perCustomerAmount: string | null; total: string } | null;
}

// Overview KPI tiles for a tenant (platform admin Overview tab, UI-SPEC §2.2).
export const getSummary = (tenantId: string): Promise<TenantSummary> =>
  httpRequest.get(`/bil/admin/tenants/${tenantId}/summary`);
